import type { ComponentType, SVGProps } from 'react'

interface IconButtonProps {
  icon: ComponentType<SVGProps<SVGSVGElement>>
  onClick: () => void
  title?: string
  className?: string
  iconClassName?: string
  children?: React.ReactNode
}

export const IconButton = ({
  icon: Icon,
  onClick,
  title,
  className = '',
  iconClassName = 'w-4 h-4',
  children,
}: IconButtonProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      title={title}
      className={`btn flex gap-1 items-center ${className}`}
      aria-label={title}
    >
      <Icon className={iconClassName} />
      {children}
    </button>
  )
}
